export { default as RewardsBadge } from './RewardsBadge';
export type { RewardsBadgeProps } from './types';
